import { motion } from 'framer-motion';

export default function PackagesSection() {
  const packages = [
    {
      name: 'Inicio',
      price: '$500',
      period: '/mes',
      description: 'Perfecto para comenzar tu transformación digital con efectos 3D básicos',
      features: [
        'Efectos básicos de partículas',
        'Cards 3D interactivas',
        'Animaciones fluidas',
        'Diseño responsive',
        'Soporte por email',
        '1 revisión mensual'
      ],
      gradient: 'from-cyan-500 to-blue-600',
      popular: false
    },
    {
      name: 'Pro',
      price: '$1,499',
      period: '/mes',
      description: 'Entorno completo con navegación orbital y hologramas avanzados',
      features: [
        'Todo lo de Inicio',
        'Navegación orbital 3D',
        'Hologramas interactivos',
        'Dashboards volumétricos',
        'Integración IA completa',
        'Soporte prioritario 24/7',
        'Revisiones ilimitadas',
        'Agentes IA personalizados'
      ],
      gradient: 'from-purple-500 to-pink-600',
      popular: true
    },
    {
      name: 'Quantum',
      price: '$2,999',
      period: '/mes',
      description: 'Realidad WebGL completa con interacciones físicas y experiencia inmersiva total',
      features: [
        'Todo lo de Pro',
        'Realidad WebGL completa',
        'Física 3D avanzada',
        'Shaders personalizados',
        'Avatares 3D instructores',
        'Simulaciones complejas',
        'Equipo dedicado',
        'Desarrollo a medida',
        'Consultoría estratégica'
      ],
      gradient: 'from-yellow-500 to-orange-600',
      popular: false
    }
  ];

  return (
    <section id="packages" className="relative py-32 bg-gradient-to-b from-black via-purple-900/10 to-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-20"
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            <span className="bg-gradient-to-r from-cyan-400 to-purple-500 bg-clip-text text-transparent">
              Paquetes NEXUS 3D
            </span>
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Elige el nivel de inmersión perfecto para tu proyecto
          </p>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {packages.map((pkg, index) => (
            <motion.div
              key={pkg.name}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className={`relative group ${pkg.popular ? 'lg:scale-110 lg:z-10' : ''}`}
            >
              {pkg.popular && (
                <div className="absolute -top-5 left-1/2 transform -translate-x-1/2 z-20">
                  <div className="px-6 py-2 rounded-full bg-gradient-to-r from-purple-500 to-pink-600 text-white text-sm font-semibold shadow-lg whitespace-nowrap">
                    Más Popular
                  </div>
                </div>
              )}
              
              <div className={`absolute inset-0 bg-gradient-to-br ${pkg.gradient} opacity-10 blur-3xl group-hover:opacity-20 transition-opacity duration-500`}></div>
              
              <div className={`relative h-full p-8 rounded-3xl bg-gradient-to-br from-gray-900/80 to-gray-800/80 border-2 ${pkg.popular ? 'border-purple-500' : 'border-gray-800'} group-hover:border-cyan-500/50 backdrop-blur-sm transition-all duration-500`}>
                <div className="mb-8">
                  <h3 className="text-2xl font-bold text-white mb-2">{pkg.name}</h3>
                  <p className="text-gray-400 text-sm mb-6">{pkg.description}</p>
                  <div className="flex items-baseline">
                    <span className={`text-5xl font-bold bg-gradient-to-r ${pkg.gradient} bg-clip-text text-transparent`}>
                      {pkg.price}
                    </span>
                    <span className="text-gray-400 ml-2">{pkg.period}</span>
                  </div>
                </div>

                <ul className="space-y-4 mb-8">
                  {pkg.features.map((feature) => (
                    <li key={feature} className="flex items-start">
                      <div className={`w-6 h-6 rounded-full bg-gradient-to-br ${pkg.gradient} flex items-center justify-center mt-0.5 mr-3 flex-shrink-0`}>
                        <i className="ri-check-line text-white text-sm"></i>
                      </div>
                      <span className="text-gray-300 text-sm">{feature}</span>
                    </li>
                  ))}
                </ul>

                <a
                  href="#contact"
                  className={`block w-full py-4 rounded-full text-center font-semibold transition-all duration-300 transform hover:scale-105 whitespace-nowrap ${
                    pkg.popular
                      ? `bg-gradient-to-r ${pkg.gradient} text-white hover:shadow-2xl hover:shadow-purple-500/50`
                      : 'border-2 border-cyan-500 text-cyan-400 hover:bg-cyan-500/10'
                  }`}
                >
                  Comenzar Ahora
                </a>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
